import React from "react";
import FormText from "./form/formText.component";
import ContainerBox from "./common/containerBox.component";
import { useDispatch, useSelector } from "react-redux";
import { enterAcntNumber } from "../actions/index";
import { stateProps } from "../types";
import FormSingleInput from "./form/formSingleInput.component";

const AccntNum: React.FC = () => {
  const dispatch = useDispatch();

  const acntNumber = useSelector(
    (state: { router: History; doctorInfo: stateProps }) => state.doctorInfo.acntNumber
  );

  const onInputChange = (event: any) => {
    const { value } = event.target;
    dispatch(enterAcntNumber(value));
  };

  return (
    <React.Fragment>
      <ContainerBox>
        <FormText number={"18"} title={"Account Number"} />
        <FormSingleInput
          value={acntNumber}
          onInputChange={onInputChange}
          placeholder={"Account number"}
          InputType={"number"}
        />
      </ContainerBox>
    </React.Fragment>
  );
};

export default AccntNum;
